/**
 * @file Locks a control while its request runs.
 */

/**
 * Disables a control while its request runs. Disabling drops the focus, which would leave a keyboard user stranded, so
 * the returned function enables the control again and puts the focus back, unless it has moved elsewhere meanwhile.
 *
 * @param {HTMLInputElement|HTMLButtonElement} control
 * @returns {() => void} unlock
 */
export function lockControl(control) {
  const hadFocus = document.activeElement === control;
  control.disabled = true;

  return () => {
    control.disabled = false;
    if (hadFocus && isFocusStranded(control)) {
      control.focus();
    }
  };
}

/**
 * Chrome drops the focus of a disabled control to the body, Firefox keeps it on the control.
 *
 * @param {HTMLElement} control
 * @returns {boolean}
 */
function isFocusStranded(control) {
  const active = document.activeElement;

  return active === null || active === document.body || active === control;
}
